/**
 * @overview token业务处理
 */

const TOKEN_KEY = "course-tool-token";

const get = () => localStorage.getItem(TOKEN_KEY);

const remove = () => localStorage.removeItem(TOKEN_KEY);

const set = token => localStorage.setItem(TOKEN_KEY, token);

export default {
  remove,
  set,
  get,
};
